var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyMobility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.942 17.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-499.248 -502)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(499.248 502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.879,502.623l-4.019-.576a4.727,4.727,0,0,0-1.334,0l-4.018.576a.3.3,0,0,0-.251.373l1.846,7.4a.453.453,0,0,0,.416.326h1v7.376l1.258,1.341h.733l.02-.02v-.651h-.671v-.671h.671v-.67h-.671v-.671h.671v-.671h-.671v-.671h.671v-.671h-.671v-.671h.671v-.67h-.671v-.671h.671v-.671l.223-1.341h.224l.223,1.341v6.7l.671-.661v-7.376h1a.453.453,0,0,0,.416-.326l1.846-7.4A.3.3,0,0,0,513.879,502.623Zm-4.685,3.358a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,509.194,505.981Z",
    transform: "translate(-504.248 -502)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M531.888,513.09l.9-.6a.453.453,0,0,0,.165-.5l-2.04-5.674-1.664,7.205A1.35,1.35,0,0,1,528,514.654v.8a.348.348,0,0,0,.41.005l.725-.509,4.072,6.221,1.852.368.6-.408.315-1.825Z",
    transform: "translate(-20.789 -2.867)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMobility);
export default __webpack_public_path__ + "static/media/MyMobility.60c1239cd143e8c671f0fa9ed8c0624f.svg";
export { ForwardRef as ReactComponent };